import {ValueObject} from '@s-ui/domain'

export class VehicleCertificationFeaturesListValueObject extends ValueObject {
  /**
   * @param {Array} items
   * */

  getItems = () => this._items
}
